var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "complainant_project_info" },
    [
      _c(
        "el-form",
        {
          ref: "ruleForm",
          staticClass: "ruleForm",
          attrs: {
            model: _vm.ruleForm,
            rules: _vm.rules,
            "label-width": "250px",
          },
        },
        [
          _c(
            "el-form-item",
            {
              staticClass: "single-row",
              attrs: { label: "标段名称：", prop: "projectName" },
            },
            [
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.ruleForm.complaintProjectVo &&
                      _vm.ruleForm.complaintProjectVo.bidSectionName
                  )
                ),
              ]),
            ]
          ),
          _c(
            "el-form-item",
            {
              staticClass: "double-row",
              attrs: { label: "标段编号：", prop: "projectCode" },
            },
            [
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.ruleForm.complaintProjectVo &&
                      _vm.ruleForm.complaintProjectVo.bidSectionCode
                  )
                ),
              ]),
            ]
          ),
          _c(
            "el-form-item",
            {
              staticClass: "double-row",
              attrs: { label: "招标项目编号：", prop: "projectCode" },
            },
            [
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.ruleForm.complaintProjectVo &&
                      _vm.ruleForm.complaintProjectVo.tenderProjectCode
                  )
                ),
              ]),
            ]
          ),
          _c(
            "el-form-item",
            {
              staticClass: "single-row",
              attrs: {
                label: "招标项目名称：",
                prop: "corporateRepresentative",
              },
            },
            [
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.ruleForm.complaintProjectVo &&
                      _vm.ruleForm.complaintProjectVo.tenderProjectName
                  )
                ),
              ]),
            ]
          ),
          _c(
            "el-form-item",
            {
              staticClass: "double-row",
              attrs: { label: " 招标人：", prop: "tenderer" },
            },
            [
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.ruleForm.complaintProjectVo &&
                      _vm.ruleForm.complaintProjectVo.tendererName
                  )
                ),
              ]),
            ]
          ),
          _c(
            "el-form-item",
            {
              staticClass: "double-row",
              attrs: { label: " 招标代理机构：", prop: "tenderAgent" },
            },
            [
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.ruleForm.complaintProjectVo &&
                      _vm.ruleForm.complaintProjectVo.tenderAgencyName
                  )
                ),
              ]),
            ]
          ),
          _c(
            "el-form-item",
            {
              staticClass: "double-row",
              attrs: { label: " 中标人：", prop: "tenderer" },
            },
            [
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.ruleForm.complaintProjectVo &&
                      _vm.ruleForm.complaintProjectVo.winnerName
                  )
                ),
              ]),
            ]
          ),
          _c(
            "el-form-item",
            {
              staticClass: "double-row",
              attrs: { label: " 中标时间：", prop: "bidWinTimes" },
            },
            [
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.ruleForm.complaintProjectVo &&
                      _vm.ruleForm.complaintProjectVo.winnerTime
                  )
                ),
              ]),
            ]
          ),
          _c(
            "el-form-item",
            {
              staticClass: "double-row",
              attrs: { label: "中标金额：", prop: "bidAmount" },
            },
            [
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.ruleForm.complaintProjectVo &&
                      _vm.ruleForm.complaintProjectVo.winnerPrice
                  )
                ),
              ]),
            ]
          ),
          _c(
            "el-form-item",
            {
              staticClass: "single-row",
              attrs: {
                label: "投诉人参加本项目投标情况：",
                prop: "bidProject",
              },
            },
            [
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.ruleForm.complaintProjectVo &&
                      _vm.ruleForm.complaintProjectVo.tenderProjectInfo
                  )
                ),
              ]),
            ]
          ),
          _c(
            "el-form-item",
            {
              staticClass: "single-row",
              attrs: {
                label: "投诉人与本项目利害关系情况：",
                prop: "interestsProject",
              },
            },
            [
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.ruleForm.complaintProjectVo &&
                      _vm.ruleForm.complaintProjectVo.tenderRelationInfo
                  )
                ),
              ]),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }